import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import IRouter from './router';
import reportWebVitals from './reportWebVitals';
import {Provider} from 'react-redux';
import store from './store';

ReactDOM.render(
  <React.StrictMode>
      <Provider store={store} >
          <App>
              <IRouter />
          </App>
      </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
reportWebVitals();
